<template>
  <div class="tour-accommodation">
    <div
      v-for="{ id, name } in accommodation"
      :key="id"
      class="tour-accommodation__item"
    >
      <div class="tour-accommodation__tooltip u-flex-shrink-0">
        <tooltip>
          <template #default>
            <svg-inline class="u-decor u-text-secondary">
              <icon icon="icon-info" />
            </svg-inline>
          </template>
          <!-- <template #content>
            <div v-html="comment" />
          </template> -->
        </tooltip>
      </div>
      <div
        class="tour-accommodation__name u-flex-grow font-semibold"
        v-html="name"
      ></div>
      <!-- <div class="tour-accommodation__price u-flex-shrink-0 font-semibold">
        {{ symbol }} {{ price }}
      </div> -->
    </div>
  </div>
</template>

<script>
import Tooltip from "@/components/ui-kit/tooltip/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    Tooltip,
    SvgInline,
    Icon,
  },
  props: {
    accommodation: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-accommodation {
  &__item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-top: 1px solid var.$gray-light;

    @include mixin.size-lg-min {
      padding: 24px 0;
    }

    > * + * {
      margin-left: 12px;
    }
  }

  &__tooltip {
    width: 18px;
  }
}
</style>
